import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// Recordings are auth-protected, so fetch as blob and play inline.
export function RecordingPlayer({ call }) {
  const [src, setSrc] = useState("");
  const [busy, setBusy] = useState(false);
  if (!call.recording_url) return "—";
  if (src) return <audio src={src} controls autoPlay className="h-8 w-56" data-testid={`recording-audio-${call.id}`} onClick={(e) => e.stopPropagation()} />;
  const load = async (e) => {
    e.stopPropagation(); setBusy(true);
    try {
      const { data } = await api.get(call.recording_url.replace(/^\/api/, ""), { responseType: "blob" });
      setSrc(URL.createObjectURL(data));
    } catch { toast.error("Could not load recording"); }
    setBusy(false);
  };
  return <button className="text-[#4F46E5] text-xs font-semibold underline" onClick={load} data-testid={`recording-play-${call.id}`}>{busy ? "Loading…" : "Play"}</button>;
}
